import { createContext } from "react";
import { ApprovalUserContext } from "../interfaces/ApprovalUserContext";

export const UserContext = createContext<ApprovalUserContext>(
  {} as ApprovalUserContext
);